import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AdminUserService } from '../../user/admin-user.service';
import { AdminUserModel } from 'src/app/pagesAdmin/admin-users/admin-user.model';

@Injectable({ providedIn: 'root' })
export class AuthAdminGuard implements CanActivate {
  constructor(
    private adminUserService: AdminUserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (
      !this.adminUserService.isLogged() ||
      this.adminUserService.isTokenExpired() ||
      !this.adminUserService.hasRole('ROLE_ADMIN')
    ) {
      this.router.navigate(['/auth-admin/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    return true;
  }
}
